import type {MultiIdSelector} from "./types";
import type {SearchResultType, Watch} from "../graphql/types";

/**
 * @param searchResult Result to apply to IDs
 * @param watch Watch with IDs to apply function to
 * @param applyFunc Function to apply result to IDs
 * @return Updated IDs
 */
export function applySearchResultToWatchIds(
  searchResult: Partial<SearchResultType>,
  watch: Partial<Watch>,
  applyFunc: (
    searchResult: Partial<SearchResultType>,
    ids: number[] | string[]
  ) => void
): MultiIdSelector {
  const parkIds: number[] = (watch.parks || []).map(
    (park: SearchResultType) => park.id as number
  );
  const facilityIds: number[] = (watch.facilities || []).map(
    (facility: SearchResultType) => facility.id as number
  );
  const unitIds: number[] = (watch.units || []).map(
    (unit: SearchResultType) => unit.id as number
  );

  if (searchResult.__typename && searchResult.id) {
    if (searchResult.__typename === "Park") {
      applyFunc(searchResult, parkIds);
    } else if (searchResult.__typename === "Facility") {
      applyFunc(searchResult, facilityIds);
    } else if (searchResult.__typename === "Unit") {
      applyFunc(searchResult, unitIds);
    } else {
      throw new Error("Unexpected target type");
    }
  }

  return {
    parkIds,
    facilityIds,
    unitIds,
  };
}

/**
 * @param searchResult
 * @param watch
 * @return Updated Ids
 */
export function addSearchResultToWatchIds(
  searchResult: Partial<SearchResultType>,
  watch: Partial<Watch>
): MultiIdSelector {
  return applySearchResultToWatchIds(
    searchResult,
    watch,
    (result: Partial<SearchResultType>, ids: number[] | string[]) => {
      if (!result.id) {
        return;
      }

      // @ts-ignore
      if (result.id && ids.indexOf(result.id) === -1) {
        // @ts-ignore
        ids.push(result.id);
      }
    }
  );
}

/**
 * @param searchResult
 * @param watch
 * @return Updated IDs
 */
export function removeSearchResultFromWatchIds(
  searchResult: Partial<SearchResultType>,
  watch: Partial<Watch>
): MultiIdSelector {
  return applySearchResultToWatchIds(
    searchResult,
    watch,
    (result: Partial<SearchResultType>, ids: number[] | string[]) => {
      if (!result.id) {
        return;
      }

      // @ts-ignore
      const index = ids.indexOf(result.id);
      if (index > -1) {
        ids.splice(index, 1);
      }
    }
  );
}
